import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import styled, { css } from 'styled-components';
import { focusVisibleWithOutline } from '../utils/focus-indicator';
var inheritStyle = function inheritStyle(_ref) {
  var inherit = _ref['data-inherit'];
  return "\n  ".concat(inherit ? "font-size: inherit;" : '', "\n  ").concat(inherit ? "line-height: inherit;" : '', "\n");
};
var textColorStyle = function textColorStyle(_ref2) {
  var inherit = _ref2['data-inherit'],
    theme = _ref2.theme;
  return "\n  color: ".concat(inherit ? 'inherit' : theme.palette.content, ";\n");
};
var textFontWeightStyle = function textFontWeightStyle(_ref3) {
  var inherit = _ref3['data-inherit'];
  return "\n  font-weight: ".concat(inherit ? 'inherit' : '500', ";\n");
};
var textLinkCss = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  border-bottom: 1px ", "\n    ", ";\n  text-decoration: none;\n  transition: color 0.2s ease-out;\n\n  &:active,\n  &:hover,\n  &:focus {\n    text-decoration: none;\n    color: ", ";\n  }\n"])), inheritStyle, textColorStyle, textFontWeightStyle, function (_ref4) {
  var dashed = _ref4['data-dashed'];
  return dashed ? 'dashed' : 'solid';
}, function (props) {
  return props.theme.palette.actionableSecondary;
}, function (props) {
  return props.theme.palette.actionableSecondary;
});
var unstyledLinkCss = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n"])), inheritStyle);
var noUnderlineCss = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  text-decoration: none;\n"])));
var typeCss = {
  unstyled: unstyledLinkCss,
  text: textLinkCss,
  "default": '',
  'no-underline': noUnderlineCss
};
export default styled.a(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  ", "\n\n  ", "\n"])), function (props) {
  return typeCss[props['data-type']];
}, function (_ref5) {
  var $bold = _ref5.$bold;
  return $bold ? css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n          font-weight: 500;\n        "]))) : '';
}, focusVisibleWithOutline({
  offset: 'default',
  radius: 'default'
}));
//# sourceMappingURL=styles.js.map